<template>
  <div>
    <el-button type="success" @click="tianjia()">添加</el-button>
    <!-- <el-button type="warning" @click="shangbian()">编辑</el-button>
    <el-button type="danger" @click="diershanchu()">删除</el-button> -->
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-table
        ref="multipleTable"
        :data="tabledata"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="id" label="id"> </el-table-column>
        <el-table-column prop="user_id" label="用户id"> </el-table-column>
        <el-table-column prop="user_name" label="用户姓名"> </el-table-column>
        <el-table-column prop="order_id" label="订单id"> </el-table-column>
        <el-table-column prop="phone" label="手机号" width="160"> </el-table-column>
        <el-table-column prop="send_reason" label="发送原因" width="160"> </el-table-column>
        <el-table-column prop="order_lease_period" label="订单租期">
        </el-table-column>
        <el-table-column prop="send_content" label="发送内容" width="400">
        </el-table-column>
        <el-table-column prop="send_status" label="是否成功"> </el-table-column>
        <el-table-column prop="reason_for_receipt" label="回执原因">
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间" width="160"> </el-table-column>
        <el-table-column prop="update_time" label="更新时间" width="160"> </el-table-column>
        <!-- 操作 -->
        <el-table-column fixed="right" label="操作" width="160">
          <template slot-scope="scope" v-if="!scope.row.is_top_row">
            <el-button @click="bianji(scope.row)" type="warning" size="small"
              >编辑</el-button
            >
            <el-button @click="shanchu(scope.row)" type="danger" size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px">
        <el-button @click="toggleSelection()">取消选择</el-button>
      </div>

      <!-- 编辑 -->
      <el-dialog
        title="编辑"
        :visible.sync="dialogTableVisible1"
        width="600px"
        :before-close="dialogTableVisible1"
      >
        <div class="yanghi">
          <p style="width: 20%">用户id</p>
          <el-input v-model="user_id" placeholder="请输入内容"></el-input>
        </div>
        <div class="yanghi">
          <p style="width: 20%">用户姓名</p>
          <el-input v-model="user_name" placeholder="请输入内容"></el-input>
        </div>
        <div class="yanghi">
          <p style="width: 20%">订单id</p>
          <el-input v-model="order_id" placeholder="请输入内容"></el-input>
        </div>
        <div class="yanghi">
          <p style="width: 20%">手机号</p>
          <el-input v-model="phone" placeholder="请输入内容"></el-input>
        </div>
        <div class="yanghi">
          <p style="width: 20%">发送原因</p>
          <el-input v-model="send_reason" placeholder="请输入内容"></el-input>
        </div>
        <div class="yanghi">
          <p style="width: 20%">订单租期</p>
          <el-input
            v-model="order_lease_period"
            placeholder="请输入内容"
          ></el-input>
        </div>

        <div class="yanghi">
          <p style="width: 20%">发送内容</p>
          <el-input v-model="send_content" placeholder="请输入内容"></el-input>
        </div>

        <div class="yanghi">
          <p style="width: 20%">是否成功</p>
          <el-radio v-model="send_status" label="不成功">不成功</el-radio>
          <el-radio v-model="send_status" label="提交成功">提交成功</el-radio>
          <el-radio v-model="send_status" label="创建">创建</el-radio>
        </div>

        <div class="yanghi">
          <p style="width: 20%">回执原因</p>
          <el-input
            v-model="reason_for_receipt"
            placeholder="请输入内容"
          ></el-input>
        </div>
        <template #footer>
          <el-button @click="dialogTableVisible1 = false">取 消</el-button>
          <el-button type="primary" @click="queding5()">确 定</el-button>
        </template>
      </el-dialog>
      <!-- 添加 -->
      <el-dialog
        title="编辑"
        :visible.sync="dialogTableVisible8"
        width="600px"
        :before-close="dialogTableVisible8"
      >
        <div class="yanghi">
          <p style="width: 20%">用户id</p>
          <el-input v-model="input1" placeholder="请输入内容"></el-input>
        </div>
        <div class="yanghi">
          <p style="width: 20%">用户姓名</p>
          <el-input v-model="input2" placeholder="请输入内容"></el-input>
        </div>
        <div class="yanghi">
          <p style="width: 20%">订单id</p>
          <el-input v-model="input3" placeholder="请输入内容"></el-input>
        </div>
        <div class="yanghi">
          <p style="width: 20%">手机号</p>
          <el-input v-model="input4" placeholder="请输入内容"></el-input>
        </div>
        <div class="yanghi">
          <p style="width: 20%">发送原因</p>
          <el-input v-model="input5" placeholder="请输入内容"></el-input>
        </div>
        <div class="yanghi">
          <p style="width: 20%">订单租期</p>
          <el-input v-model="input6" placeholder="请输入内容"></el-input>
        </div>

        <div class="yanghi">
          <p style="width: 20%">发送内容</p>
          <el-input v-model="input7" placeholder="请输入内容"></el-input>
        </div>

        <div class="yanghi">
          <p style="width: 20%">是否成功</p>
          <el-radio v-model="input8" label="不成功">不成功</el-radio>
          <el-radio v-model="input8" label="提交成功">提交成功</el-radio>
          <el-radio v-model="input8" label="创建">创建</el-radio>
        </div>

        <div class="yanghi">
          <p style="width: 20%">回执原因</p>
          <el-input v-model="input9" placeholder="请输入内容"></el-input>
        </div>
        <template #footer>
          <el-button @click="dialogTableVisible8 = false">取 消</el-button>
          <el-button type="primary" @click="tianqueding5()">确 定</el-button>
        </template>
      </el-dialog>

      <!-- 编辑2 -->
      <el-dialog
        title="编辑"
        :visible.sync="dialogTableVisible3"
        width="600px"
        :before-close="dialogTableVisible3"
      >
        <div class="yanghi">
          <p style="width: 20%">用户id</p>
          <el-input v-model="user_id1" placeholder="请输入内容"></el-input>
        </div>
        <div class="yanghi">
          <p style="width: 20%">用户姓名</p>
          <el-input v-model="user_name1" placeholder="请输入内容"></el-input>
        </div>
        <div class="yanghi">
          <p style="width: 20%">订单id</p>
          <el-input v-model="order_id1" placeholder="请输入内容"></el-input>
        </div>
        <div class="yanghi">
          <p style="width: 20%">手机号</p>
          <el-input v-model="phone1" placeholder="请输入内容"></el-input>
        </div>
        <div class="yanghi">
          <p style="width: 20%">发送原因</p>
          <el-input v-model="send_reason1" placeholder="请输入内容"></el-input>
        </div>
        <div class="yanghi">
          <p style="width: 20%">订单租期</p>
          <el-input
            v-model="order_lease_period1"
            placeholder="请输入内容"
          ></el-input>
        </div>

        <div class="yanghi">
          <p style="width: 20%">发送内容</p>
          <el-input v-model="send_content1" placeholder="请输入内容"></el-input>
        </div>

        <div class="yanghi">
          <p style="width: 20%">是否成功</p>
          <el-radio v-model="send_status1" label="不成功">不成功</el-radio>
          <el-radio v-model="send_status1" label="提交成功">提交成功</el-radio>
          <el-radio v-model="send_status1" label="创建">创建</el-radio>
        </div>

        <div class="yanghi">
          <p style="width: 20%">回执原因</p>
          <el-input
            v-model="reason_for_receipt1"
            placeholder="请输入内容"
          ></el-input>
        </div>

        <template #footer>
          <el-button @click="dialogTableVisible3 = false">取 消</el-button>
          <el-button type="primary" @click="dierqueding5()">确 定</el-button>
        </template>
      </el-dialog>

      <!-- 删除 -->
      <el-dialog
        title="删除"
        :visible.sync="dialogTableVisible2"
        width="600px"
        :before-close="dialogTableVisible2"
      >
        <el-button @click="dialogTableVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="queding6()">确 定</el-button>
      </el-dialog>
      <!-- 删除2 -->
      <el-dialog
        title="删除"
        :visible.sync="dialogTableVisible4"
        width="600px"
        :before-close="dialogTableVisible4"
      >
        <el-button @click="dialogTableVisible4 = false">取 消</el-button>
        <el-button type="primary" @click="dierqueding6()">确 定</el-button>
      </el-dialog>

      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="10"
          layout="total, prev,sizes ,pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </el-tabs>
  </div>
</template>

<script>
import FengkongApi from "@/api/fengkong.js";
export default {
  data() {
    return {
      input1: "",
      input2: "",
      input3: "",
      input4: "",
      input5: "",
      input6: "",
      input7: "",
      input8: "",
      input9: "",
      dialogTableVisible2: false,
      dialogTableVisible1: false,
      dialogTableVisible3: false,
      dialogTableVisible4: false,
      dialogTableVisible8: false,
      tabledata: [],
      curPage: 1,
      pageSize: 20,
      totalDataNumber: "",
      activeName: "first",
      user_id: "",
      user_name: "",
      phone: "",
      order_lease_period: "",
      send_content: "",
      send_reason: "",
      send_status: "",
      reason_for_receipt: "",
      id: "",
      fangfa: "",
      user_name1: "",
      phone1: "",
      send_reason1: "",
      order_lease_period1: "",
      send_status1: "",
      reason_for_receipt1: "",
      send_status1: "",
      user_id1: "",
      id1: ""
    };
  },
  created() {
    this.getDtata();
  },

  methods: {
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      let self = this;

      for (let i = 0; i < val.length; i++) {
        let xing = val.length[i];
        console.log(xing);
      }
      self.user_id1 = val[0].user_id;
      self.user_name1 = val[0].user_name;
      self.order_id1 = val[0].order_id;
      self.phone1 = val[0].phone;
      self.send_reason1 = val[0].send_reason;
      self.order_lease_period1 = val[0].order_lease_period;
      self.send_status1 = val[0].send_status;
      self.reason_for_receipt1 = val[0].reason_for_receipt;
      self.send_status1 = val[0].send_status;
      self.id1 = val[0].id;
    },
    /*备注弹窗确定*/
    queding5() {
      let Params = {
        send_content: this.send_content,
        id: this.id,
        user_id: this.user_id,
        user_name: this.user_name,
        order_id: this.order_id,
        phone: this.phone,
        send_reason: this.send_reason,
        order_lease_period: this.order_lease_period,
        send_status: this.send_status,
        reason_for_receipt: this.reason_for_receipt,
        send_status: this.send_status
      };
      FengkongApi.xiugai(Params, true)
        .then(res => {
          this.dialogTableVisible1 = false;

          this.getDtata();
          this.$message({
            type: "success",
            message: "修改成功~~~"
          });
        })
        .catch(error => {});
    },
    dierqueding5() {
      let Params = {
        id: this.id1,
        send_content: this.send_content1,
        user_id: this.user_id1,
        user_name: this.user_name1,
        order_id: this.order_id1,
        phone: this.phone1,
        send_reason: this.send_reason1,
        order_lease_period: this.order_lease_period1,
        send_status: this.send_status1,
        reason_for_receipt: this.reason_for_receipt1,
        send_status: this.send_status1
      };
      FengkongApi.xiugai(Params, true)
        .then(res => {
          this.dialogTableVisible3 = false;

          this.getDtata();
          this.$message({
            type: "success",
            message: "修改成功~~~"
          });
        })
        .catch(error => {});
    },
    //添加
    tianqueding5() {
      let Params = {
        // id:this.id1,
        send_content: this.input1,
        user_id: this.input2,
        user_name: this.input3,
        order_id: this.input4,
        phone: this.input5,
        send_reason: this.input6,
        order_lease_period: this.input7,
        send_status: this.input8,
        reason_for_receipt: this.input9
      };
      FengkongApi.duanxintianjia(Params, true)
        .then(res => {
          this.dialogTableVisible8 = false;
          this.getDtata();
          this.$message({
            type: "success",
            message: "添加成功~~~"
          });
        })
        .catch(error => {});
    },
    //第一个删除
    queding6() {
      let Params = {
        id: this.id
      };
      FengkongApi.shanchu(Params, true)
        .then(res => {
          this.dialogTableVisible2 = false;
          this.getDtata();
          this.$message({
            type: "success",
            message: "删除成功~~~"
          });
        })
        .catch(error => {});
    },
    //第二个删除
    dierqueding6() {
      let Params = {
        id: this.id1
      };
      FengkongApi.shanchu(Params, true)
        .then(res => {
          this.dialogTableVisible4 = false;
          this.getDtata();
          this.$message({
            type: "success",
            message: "删除成功~~~"
          });
        })
        .catch(error => {});
    },
    bianji(row) {
      let self = this;
      self.user_id = row.user_id;
      self.user_name = row.user_name;
      self.order_id = row.order_id;
      self.phone = row.phone;
      self.send_reason = row.send_reason;
      self.order_lease_period = row.order_lease_period;
      self.send_content = row.send_content;
      self.send_status = row.send_status;
      self.reason_for_receipt = row.reason_for_receipt;
      self.id = row.id;
      self.dialogTableVisible1 = true;
    },
    shangbian() {
      let self = this;
      console.log("sadas", self.user_id1);
      // console.log(self.user_name1);

      self.dialogTableVisible3 = true;
    },
    tianjia() {
      let self = this;
      self.dialogTableVisible8 = true;
    },

    shanchu(row) {
      let self = this;
      self.id = row.id;
      self.dialogTableVisible2 = true;
    },
    diershanchu() {
      let self = this;
      self.dialogTableVisible4 = true;
      console.log(this.id1);
    },

    dialogTableVisible1() {
      this.dialogTableVisible1 = false;
    },
    dialogTableVisible2() {
      this.dialogTableVisible2 = false;
    },
    dialogTableVisible3() {
      this.dialogTableVisible3 = false;
    },
    getDtata() {
      let self = this;
      let Params = {
        page: this.curPage,
        list_rows: this.pageSize
      };
      FengkongApi.duanxin(Params, true)
        .then(data => {
          self.tabledata = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
          console.log("data", self.tabledata);
        })
        .catch(error => {});
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getDtata();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getDtata();
    },
    handleClick(tab, event) {
      console.log(tab, event);
    }
  }
};
</script>

<style>
.yanghi {
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
}
.yanghi > p {
  display: block;
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/duanxin/index.vue